module.exports = __webpack_public_path__ + "img/unit-testing.544b2029.svg";